import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PauseIcon from '@mui/icons-material/Pause';
import PendingIcon from '@mui/icons-material/Pending';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Grid, Stack, Typography } from '@mui/material';

import { TASK_STATUS } from 'utils/constants';

const TASK_HEADER_COLUMNS: { label: string; xs?: number }[] = [
  { label: 'TASK', xs: 2 },
  { label: 'DUE DATE' },
  { label: 'PROGRESS' },
  { label: 'ASSIGNEE' },
  { label: 'STATUS' },
  { label: 'PRIORITY' },
  { label: 'OPTIONS', xs: 1 },
];

export const TaskListHeader = () => (
  <Grid container spacing={1} sx={{ padding: '4px' }}>
    {TASK_HEADER_COLUMNS.map((column) => (
      <Grid key={column.label} item {...(column.xs ? { xs: column.xs } : { xs: true })}>
        <Typography variant="h4">{column.label}</Typography>
      </Grid>
    ))}
  </Grid>
);

export const getStatusIcon = (status: string) => {
  switch (status) {
    case TASK_STATUS.PENDING.value:
      return { icon: <PendingIcon sx={{ fontSize: 18 }} />, name: TASK_STATUS.PENDING.name };
    case TASK_STATUS.INPROGRESS.value:
      return { icon: <TrendingUpIcon sx={{ fontSize: 18 }} />, name: TASK_STATUS.INPROGRESS.name };
    case TASK_STATUS.COMPLETED.value:
      return { icon: <CheckIcon sx={{ fontSize: 18 }} />, name: TASK_STATUS.COMPLETED.name };
    case TASK_STATUS.CANCELLED.value:
      return { icon: <CloseIcon sx={{ fontSize: 18 }} />, name: TASK_STATUS.CANCELLED.name };
    case TASK_STATUS.ONHOLD.value:
      return { icon: <PauseIcon sx={{ fontSize: 18 }} />, name: TASK_STATUS.ONHOLD.name };
    default:
      return { icon: null, name: '' };
  }
};

export const StatusPill = (status: string) => {
  const statusDetail = getStatusIcon(status);

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      sx={{
        gap: 1,
        width: '120px',
        padding: '2px',
        borderRadius: 2,
        alignItems: 'center',
        border: '1px solid #463947',
      }}>
      {statusDetail.icon}
      <Typography variant="h4">{statusDetail.name}</Typography>
    </Stack>
  );
};

export const PriorityIndicator = (priority: string) => {
  const colorMap: Record<string, string> = {
    Low: '#A3E635',
    Medium: '#F59E0B',
    High: '#DC2626',
  };

  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: 100,
        background: colorMap[priority] ?? 'transparent',
      }}
    />
  );
};
